import { ORDER_METHODS } from '../../../../../services/exports/Constants';
import { ValidationErrors } from '../../../../../modals/order-method/types';

export default {
  title: 'Vælg lokation',
  order_methods: {
    [ORDER_METHODS.ON_SITE]: 'Bordbestilling',
    [ORDER_METHODS.PICKUP]: 'Afhentning',
    [ORDER_METHODS.DELIVERY]: 'Levering',
  },
  text_inputs: {
    address: {
      placeholder: 'Søg efter din adresse',
    },
    street_name: {
      placeholder: 'Vej',
    },
    street_number: {
      placeholder: 'Husnummer',
    },
    city: {
      placeholder: 'By',
    },
    zip: {
      placeholder: 'Postnr.',
    },
  },
  time_options: {
    asap: {
      title: 'Standard',
      description: 'Klar om {{time}} min.',
    },
    scheduled: {
      title: 'Planlæg til senere',
    },
  },
  time_drop_down: {
    today: 'I dag',
  },

  pickup: {
    address: 'Afhentningsadresse',
    when: 'Hvornår?',
  },

  delivery: {
    where: 'Hvortil?',
    when: 'Hvornår?',
    address: 'Din adresse',
    delivery_area: 'Vores leveringsradius',
  },

  buttons: {
    view_menu: 'Se menu',
    see_hours: 'Se åbningstider',
    next: 'Næste',
    change: 'Skift',
    save: 'Gem',
  },

  labels: {
    when: 'Hvornår?',
    pickup: 'Online afhentning',
    delivery: 'Levering',
    pickup_time: 'afhentningstidspunkt',
    delivery_time: 'leveringstidspunkt',
    discount: 'Kun her {{value}} online rabat',
    pre_orders_enabled: 'I øjeblikket kan du afgive en planlagt bestilling til senere',
    change_location: '← Gå tilbage til menuen, hvis du foretrækker en anden lokation',
    return: 'Tilbage',
  },

  items_dropped: {
    count_one: '{{count}} vare fjernet',
    count_other: '{{count}} varer fjernet',
    pickup_reason: '— ikke tilgængelig til afhentning.',
    delivery_reason: '— ikke tilgængelig til levering.',
  },

  error_messages: {
    [ValidationErrors.address_not_found]:
      'Vi kunne desværre ikke finde den adresse. Prøv igen ved først at indtaste vejen i adressesøgefeltet.',
    [ValidationErrors.address_not_serviceable]:
      'Din adresse ligger uden for vores leveringsområde. Vil du ændre din adresse eller skifte til afhentning? 😊',
    [ValidationErrors.no_drivers_available]:
      'Vi kan desværre ikke levere i øjeblikket. Vil du bestille til afhentning? 😊',
    pickup_unavailable: 'Vi beklager, at vi i øjeblikket ikke tilbyder afhentning.',
    delivery_unavailable: 'Vi beklager, at vi i øjeblikket ikke tilbyder levering.',
    delivery_paused: 'Vi beklager, at vi i øjeblikket ikke tilbyder levering.',
    outside_pickup_times: 'Vi tilbyder ikke afhentning på dette tidspunkt. Vores afhentningstider:',
    outside_delivery_times: 'Vi tilbyder ikke levering på dette tidspunkt. Vores leveringstider:',
    orders_paused_inactivity:
      'På grund af stor efterspørgsel kan vi ikke modtage flere onlinebestillinger lige nu. Bestil i butikken, eller prøv igen om 30 minutter.',
    orders_paused_manual_end_of_day: 'Vi har desværre lukket for resten af dagen.',
    orders_paused_manual_until_time:
      'På grund af stor efterspørgsel kan vi ikke modtage flere onlinebestillinger lige nu. Bestil i butikken, eller prøv igen fra {{pausedUntil}}',
    company_closed: 'Vi har desværre ikke åbent på dette tidspunkt.',
    pickup_closed:
      'Vi modtager afhentningsbestillinger indtil {{time}}, fordi vores tilberedningstid er {{preparationTime}} minutter.',
    delivery_closed:
      'Vi modtager leveringsbestillinger indtil {{time}}, fordi vores leveringstid er {{preparationTime}} minutter.',
    live_orders_off: 'Vi beklager, vi kan i øjeblikket ikke modtage flere onlinebestillinger. Tak for din forståelse.',
    orders_unavailable:
      '{{type}} er ikke tilgængelig på dette tidspunkt. Det næste mulige {{typeTime}} er {{day}} {{time}}.',
  },

  no_couriers: {
    with_code:
      'Vi beklager, vi har ingen ledige chauffører lige nu. Prøv igen senere, eller bestil til afhentning og brug kampagnekoden <PromoCode>{{code}}</PromoCode> ved betaling.',
    without_code: 'Vi beklager, vi har ingen ledige chauffører lige nu. Prøv igen senere, eller bestil til afhentning.',
    copied: 'Kampagnekode kopieret',
  },
};
